import CrudPage from "../components/CrudPage";

export default function Employees() {
  return <CrudPage
    title="Funcionários" subtitle="Equipe e Comissões" endpoint="/employees" testPrefix="employees"
    fields={[
      { k: "name", label: "Nome" },
      { k: "role", label: "Cargo" },
      { k: "phone", label: "Telefone" },
      { k: "salary", label: "Salário", type: "number" },
      { k: "commission_percent", label: "Comissão (%)", type: "number" },
    ]}
  />;
}
